webpackJsonp([42896104772529],{

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _digitalRealities = __webpack_require__(21);
	
	var _digitalRealities2 = _interopRequireDefault(_digitalRealities);
	
	var _SlideshowFooter = __webpack_require__(8);
	
	var _SlideshowFooter2 = _interopRequireDefault(_SlideshowFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prev = '/digital-realities/ar_colony-square';
	var next = '/digital-realities/what-is-ar';
	
	var sliderImages = _digitalRealities2.default[0].slideshow.map(function (img, idx) {
	    return _react2.default.createElement(
	        'div',
	        { key: 'image-' + idx },
	        _react2.default.createElement('img', { src: img, alt: '' })
	    );
	});
	
	var DigitalRealities = function DigitalRealities(props) {
	    return _react2.default.createElement(
	        'div',
	        { id: 'digital-reality-landing' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'IMBIBE - Digital Realities: What is Virtual Reality?'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'What is Virtual Reality?' })
	        ),
	        _react2.default.createElement('img', { src: 'http://dev.imbibe.info/images/vr_what-is-vr/hero.jpg' }),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'What is VR?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Officially, Virtual Reality is \u201Cthe computer-generated simulation of a three-dimensional image or environment that can be interacted with in a seemingly real or physical way by a person using special electronic equipment, such as a helmet with a screen inside or gloves fitted with sensors.\u201D'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Virtual Reality uses a set of video goggles and, optionally, audio headphones to present an experience unique to the user and without limitation from the real world.  "Virtual Reality" is also the catch-all term for anything related to a virtual experience.'
	                    )
	                ),
	                sliderImages
	            )
	        ),
	        _react2.default.createElement(_SlideshowFooter2.default, { vr: true, prev: prev, next: next })
	    );
	};
	
	exports.default = DigitalRealities;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digital-realities-what-is-vr-js-a974d7d7b0d2c1ec4fa3.js